import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpModule ,Http} from '@angular/http';
import { icbRoutingModule } from './icb-routing.module';
import { IcbComponent } from './icb.component';
import { t2tDataComponent } from './t2t/data/data.component';
import { t2tSummaryComponent } from './t2t/summary/summary.component';
import { t2tConfirmComponent } from './t2t/confirm/confirm.component';
import { t2cDataComponent } from './t2c/data/data.component';
import { t2cSummaryComponent } from './t2c/summary/summary.component';
import { t2cConfirmComponent } from './t2c/confirm/confirm.component';
import { FileUploadModule } from '../fileUpload.module';
import { languageDialog } from '../layout/header/header.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { DetailsComponent } from '../icb/detail/details.component';
import { ProgressStatusComponent } from '../progress-status/progress.component';
import { ViewDetailDialog } from '../icb/detail/details.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        icbRoutingModule,
        FileUploadModule,
        Daterangepicker,
        NguiAutoCompleteModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            deps: [Http]
        }),
        // NgMultiSelectDropDownModule.forRoot()
    ],
    declarations: [
        ViewDetailDialog,
        FileUploadComponent,
        IcbComponent,
        t2tDataComponent,
        t2tSummaryComponent,
        t2tConfirmComponent,
        t2cDataComponent,
        t2cSummaryComponent,
        t2cConfirmComponent,
        languageDialog,
        DetailsComponent,
        ProgressStatusComponent
    ],
    entryComponents: [languageDialog,ViewDetailDialog],
    exports: []
})

export class IcbModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/icb.module.ts